import { Badge, Button, FlexProps } from '@chakra-ui/react'
import { ddsTokens } from '@ds/index'
import { DDSTheme } from '@ds/index'
import { COLORS } from '@ds/tokens/legacy/colors'
import React from 'react'

import { BTN } from '@/styles/components/button'

interface AnalyticsTabProps extends FlexProps {
	label: string
	isSelected?: boolean
	isDisabled?: boolean
	comingSoon?: boolean
	onClick?: () => void
}

const AnalyticsTab: React.FC<AnalyticsTabProps> = ({
	label,
	isSelected = false,
	isDisabled = false,
	comingSoon = false,
	onClick,
}) => {
	const tokens = ddsTokens[DDSTheme.light]

	return (
		<Button
			variant={BTN.secondary_v2}
			size="sm"
			{...(isSelected && {
				color: tokens.primitive.light.primary[700],
				background: tokens.primitive.light.primary[50],
			})}
			color={isSelected ? COLORS.purple[9] : undefined}
			onClick={onClick}
			isDisabled={isDisabled}
			gap={2}
			_hover={{
				bg: COLORS.background[12],
				borderColor: COLORS.background[12],
				cursor: isDisabled ? 'not-allowed' : 'pointer',
				_disabled: {
					borderColor: COLORS.gray[5],
				},
			}}
		>
			{label}
			{comingSoon && <Badge>soon</Badge>}
		</Button>
	)
}

export default AnalyticsTab
